module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As soon as Katanji had left through the waiting room, Wallie went out by the other door. His guards sprang to their feet, scattering knucklebones and money, but he spoke only to Filurz. “I need you to come with me, the rest of you stay. If Master Horkoda comes looking for me, we’ll be down in the kitchen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Leaving a dozen eyes stretched wide with amazement, he marched out into the hallway. “I hope you know the way to the kitchen, because I don’t.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, mentor. Along here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Swordsmen tended to be short, since agility mattered more than strength. Filurz was one of the shortest seniors in the Tryst, a swarthy little man with a high opinion of his own opinions, which he tended to offer unasked. Wallie usually overlooked his presumption, because he had a high opinion of them too. Too many swordsmen were either dumb jocks or toadyish yes-men.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“This may not be good mentorship,” he said as they started down a long flight of stairs, “but I may be about to involve you in a major felony.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“In a good cause, I hope?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think so. Adept Sevolno told you about the attempt on my life last night. Did he tell you where he confined the prisoner?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“In the cell in your palace, my lord.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie had a jail in his basement that his guards used as a brig if one of their number came on duty drunk, or otherwise offended. He had excused it to Jja on the grounds that a palace that didn’t have everything wouldn’t be much of a palace, would it? The children often played in it on rainy days.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I want you to arrange for her to be taken to the city jail and locked up in the dingiest, smelliest cell they’ve got. But she must be on her own. The city jail is usually pretty full, as I recall.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, my lord. I’ll have to get a cell emptied for her. Not that they won’t do it, or anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Not when a swordsman of his rank demanded it.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And obviously I want her very well guarded. Requisition some swordsmen to keep watch. There may be attempts to rescue her or kill her.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And in either case we try to take prisoners?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course. Tomorrow we’ll give her some company. Dig up some baby-faced junior who’ll cooperate and be discreet about it afterwards. One who can read. We’ll paint over his facemark and put him in her cell; see if she’ll talk.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Adept Sevolno said—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes, I know. She has no tongue. But she can still signal yea or nay.” If she were a sorcerer, she would be able to write.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Filurz opened a door, letting Wallie walk through into warm, cozy odors of freshly baked bread. Apprentice Vixini was leaning back against a high worktable, gnawing on half a loaf while chatting up a couple of young slave girls. No doubt the older cooks in the distance disapproved of this, but they were not daring to criticize a swordsman, even a lowly Second. Addis, son of Nnanji, was hunched over, leaning hands and elbows on the worktable, watching but not participating. He was probably fair game for teasing at the moment.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie had not seen the boys together for a while and the contrast startled him. Apart from not growing facial hair, the men of the People went through much the same adolescent metamorphosis as earthly males. Vixini had crossed that divide. He was a young man, close to his final adult height, broad, and piling on muscle, while Addis was still a child, just about to start his growth spurt. His arms and legs were spindly, his face elfin and androgynous. He looked absurdly immature and spindly beside his brawny friend, although there was less than two years between them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vixi whipped the bread out of sight. The girls fled. Addis straightened up and gave Wallie the salute to a superior. Wallie responded. He often wondered how much of the day the People wasted in these useless rituals.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Son, I want you to go straight to Treasurer Katanji at his home. He’ll give you a package. Bring it back to the lodge and give it to Master Filurz, who will have some delicious hot sutras waiting for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Vixini gave his stepfather mentor a look of a sort that respectful protégés should not, but repeated his orders smartly and departed. Most apprentices would be jumping up and down with excitement at the prospect of an early promotion.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie bent and leaned his forearms on the workbench to put his eyes roughly level with those of Addis, who was now upright. The boy certainly didn’t look like a swordsman, or likely to look like one for quite some time. Instead of his father’s red hair and pale eyes, he had his Uncle Katanji’s jet irises and black curls, and probably his crafty brain as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“About that problem you asked Vixi to mention to me.” Vixini had not actually said that Addis had asked for Shonsu’s help, but that had been the gist.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The boy said cautiously, “Yes, Uncle?” while glancing at Horkoda to decide if he were in on the plot. A conspiracy to frustrate the will of a liege was treason, no matter how thinly one sliced it. Any son of Nnanji and Thana was certain to be as open to argument as a nickel-iron asteroid, and Addis was stubborn in spades. If he wanted to fail the swordsmen’s agility tests, he would instantly develop not just three feet, but five or seven. He might even refuse to swear to the code and dare the resulting scandal.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’m working on it. Right now I want you to disappear, so I don’t know where you are. Where’s your escort?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Addis bit his lip and looked down at the bench. “Seeing that I was going out with Vixi and just coming to the lodge, my lord, I thought I didn’t need to interrupt their breakfast.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Terms of address were very important in the World, and by mentioning escort Wallie had just gone from honorary uncle to a lord of the Seventh. Wildness was understandable in a high-spirited adolescent whose friends were all disappearing into the discipline of crafts, but it was also very foolish in his case. Although Casr was unbelievably law-abiding by terrestrial standards, it still had scoundrels, from would-be assassins on down. There would be no limit to the ransom Thana would pay to have her son returned. were he ever kidnapped.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I have told you a dozen times that Vixini is not an escort. He’s only an apprentice and there’s only one of him. You’re a very "), _c('i', [_vm._v("pretty ")]), _vm._v("boy, Addis, son of Nnanji. You have a lovely smile.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Addis looked up with horror, face flaming at the insult. “If any slob tries anything like that with me, I’ll rip his balls off.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, well, that’s different. I didn’t know you were expert in martial arts! Show me. Put a headlock on Master Filurz.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Master Filurz drew his sword and laid it on the table, out of the way. Then he hunched his shoulders, waiting for the attack.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Addis hung his head again, probably to hide some teeth being ground. “I didn’t mean it that way, my lord.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You didn’t? Addis, nasty things can happen to pretty boys, no matter who their fathers are.” And here was an excellent opportunity to test the lad’s swordsman potential without his realizing. Wallie turned to the frowning Filurz. “Do you know of anyone in the Tryst who’s an expert in gutter fighting? Things like choking, eye gouging, finger breaking, biting, fishhooking, kidney punching?” The swordsmen’s sutras strictly forbade fighting with any weapon except a sword, but swordsmen were more born than made, and they sprang from all sorts of backgrounds. The Tryst could usually spit forth an expert in almost anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Filurz actually laughed. “You have one of the best brawlers right under your nose, my lord—Swordsman Helbringr. Her father runs a tavern on the dockside at Quo. She and her brothers grew up as a rat pack bouncing drunks. And each other, I suspect.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie enjoyed having a bodyguard named Helbringr, although the name did not mean what it would sound like in English, but he hadn’t known of her curious background. She would probably achieve promotion to Fourth soon, and there were few women of that rank in the Tryst yet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He said, “Excellent. If you refuse to accept a bodyguard, Addis son of Nnanji the swordsman, then you’ll have to learn how to defend yourself properly. Stay here, and Adept Filurz will send Swordsman Helbringr down to collect you. Adept, I don’t want to know where she takes him. I want him taught how to defend himself with his bare hands. And feet, and teeth. I’ll collect what’s left of him later, probably around sunset. Well, Addis? You man enough to accept some bruises in a good cause?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The liege’s son was unsure how to take this alarming prospect. Behind the bright eyes, a subtle but inexperienced young mind was calculating how best to respond.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Wrestling with a woman?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll bet she can wipe the floor with you, and the ceiling as well.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Puberty, here I come?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, you sound just like your Uncle Katanji. Wait here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie headed back upstairs with Filurz.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Filurz could be quite subtle when he needed to be, which wasn’t often. “My lord, the boy seems to think you’ve just sentenced him to a beating.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Whatever could have given him that idea? No broken bones, of course, but he’s been warned too often.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I’ll tell Helbringr to make sure he won’t forget this time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Also, adept, please pick out four Thirds to examine Vixini at the assembly. You willing to tell lies in a good cause?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Of course.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then you may explain to them in confidence that the boy is far too cocksure of himself and I want him taught a lesson in humility. In other words, I will not be offended however tough they are on him. I don’t want the Tryst to think my son is being given special treatment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He’s still very young to be even a Second, if I may say so, mentor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No he might not say so! As well as captain of Wallie’s bodyguard, Filurz was also his protégé, and by addressing him as mentor, had just reminded him of that fact. He wanted promotion to Fifth, and was hinting that Wallie was neglecting him, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tell them that too. I don’t want you fixing this promotion, understand? Very few Thirds are capable of beating Vixi at fencing now, as you know. I am directing you to make sure that the sutra test is as brutal as possible, so the spectators can’t start rumors of favoritism. No easy ones, understand?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie had been holding Vixi back because he was not mature enough for the responsibilities usually given to Thirds. Yesterday that had seemed right; after the events of the night, it felt wrong, whatever Vixini himself wanted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sometimes a despot just had to be despotic.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Horkoda had done a thorough job of weeding the antechamber. Only four swordsmen remained, all needing approval of plans for celebrating the liege’s return. The program had become traditional. There must be a big thanksgiving service in the temple, a banquet at which minstrels would sing of deeds of arms—mentioning Lord Nnanji at every excuse—and an assembly of the Tryst, at which missions would be announced, novices admitted, and candidates for promotion would demonstrate their fencing. Any try at promotion was a public event, but the outcome was never certain, and a candidate who failed in front of an assembly made both himself and his mentor look foolish. The betting could be ferocious, which provided opportunities for gain, both legal and illegal. To throw a match was “to do a snail”, since snails moved very slowly and coiled up inside their shells when threatened. Some bouts where both fencers were obviously trying to lose had given birth to legends.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("None of this could be allowed to interfere with the annual celebration of Healers’ Day, two weeks away, although that would include some of the same events.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie did not need long to approve the plans, but the sun was casting very short shadows when he finished. The day was close to noon. Why had there been no word of Nnanji’s progress? Neither man put the problem into words, but Wallie could see that Horkoda was as concerned as he was.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I shall go and call on the wizard,” he said. “Send a runner for me as soon as you hear any news.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The sorcerers’ tower stood just outside the lodge on the landward side, and normally Wallie would have taken only one or two companions with him on his stroll across the plaza. After last night’s episode and Nnanji’s strange delay, he took his entire bodyguard. Today every moment must be put to use.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You also wish to try for promotion, adept?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Filurz brightened. “If you believe I am ready, mentor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Certainly. You only are seven sutras short, as I recall. Here goes. "), _c('i', [_vm._v("Number 975, On the Control of Crowds: The Epigram…”")])])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In most cities the sorcerers built their towers of the darkest stone they could find, but Casr possessed only one building stone, which Wallie identified as a micaceous arkose. It came in attractive shades of pink through gold. Some quarries produced it in fissile slabs that made good roofing tiles, so on sunny days the whole city shone as if it were made of bronze. If the sorcerers felt cheated that their tower could not appear as menacing as they would like, they had never said so. The Casr tower was only a part of a larger complex including several more orthodox buildings. How many people lived and worked there was, like all sorcerous matters, a secret. So was whatever they got up to inside, but whatever it was frequently involved sinister flickering lights and irritating, jagged noises.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No one could doubt that it was the sorcerers’ lair, though. Pigeons strutted on the ground outside, looking for grains of the food scattered there for them. The roof of the tower itself sported dovecotes and perching wires. The sorcerers’ facemarks were feathers, perhaps because they held birds sacred, or perhaps because they had invented writing and used quill pens to do so.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Out of courtesy, Wallie had sent a herald to announce his coming, and he was ushered at once upstairs and into the presence of Lord Woggan, sorcerer of the Seventh, the wizard of Casr. As usual, Woggan received him in his study, which resembled no other room Wally had seen in the World, in that it featured shelves laden with leather-bound books. Apart from that, the room contained few comforts, all the chairs being hard-backed and upright, the floor tiled, the exposed walls undecorated. He strongly suspected that receiving non-sorcerer visitors was its only purpose and, if so, it contained no secrets or valuables. Even the books might be fakes, for his hints that he would love to borrow some of them had always been ignored. The windows were small and barred, commanding a good view of the lodge grounds.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lord Woggan bore so little resemblance to Rotanxi, the sorcerer with whom Wallie had negotiated the epoch-making treaty, that they must have been brewed in different cauldrons. He was short and had once been plump, but now his fish-belly-pale face looked as if it had melted, sagging into jowls, bags, and folds, and settling his mouth in an expression of permanent disapproval. Nothing more of him was visible inside his bulky blue brocade gown, and even his hands usually remained hidden in his sleeves.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As the visitor, Wallie saluted first. The sorcerer responded with the customary hand gestures, but using words that differed from the People’s standard by invoking the Fire God instead of the Goddess. “Please do be seated, lord swordsman,” he added.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("No stool being provided to accommodate sword-bearing guests—they never were—Wallie turned a chair sideways and sat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I shan’t keep you, my lord,” he said. “I am sure you are busy. I just wanted to ask about that curious message from Lord Nnanji last night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He had not truly expected to catch Woggan out, and the old man’s reply was the predictable, “Which message was that, my lord?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Anyone who thought that the wizard of Casr did not read the liege lords’ mail ought to have his head bronzed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The Tryst and its troops in the field had three ways of communicating with one another. The safest was to dictate the message to a couple of third-rank swordsmen with good memories, put them on a ship, and wait the better part of a year for a reply. That was safe because most of the People were still preliterate and their memories were honed like razors; also because no one tampered lightly with two journeyman swordsmen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The second was to write or dictate a letter and have it delivered by the river folk in relays, from town garrison to town garrison. Letters could be lost or intercepted.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The fast way was pigeon post, but the sorcerers ran the pigeons and charged for their use. Moreover, the birds would only fly homeward and thus had to be physically transported to their point of departure. To carry a word from the farthest reaches of the empire back to Casr would require many flights. That was certainly the least reliable and least secure method.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It came in late, addressed to me from Lord Nnanji, and said only, ‘Where is Lord Mibullim?’ As we have no Mibullim of any rank in the Tryst and Lord Nnanji did not stipulate a craft, we assume it must refer to one of your brother sorcerers, my lord.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“If we had a Seventh by that name, I should know him, certainly.” Woggan rose stiffly, went to a bookcase, chose a leather-bound volume, and fingered through it until he found what he wanted. He pursed wizened lips, replaced the book, and returned to his chair. “No, my lord, we have no record of a Mibullim in the Vul coven in the last century or so.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How about other covens, then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Doughy smile: “You will have to ask them, I’m afraid. We sorcerers are not as well unified as you swordsmen.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Wallie could have scripted the entire conversation in advance. For thousands of years, swordsmen had slain sorcerers on sight, until he and Rotanxi had made a peace treaty. Nnanji had accepted it—to everyone’s astonishment—and had persuaded the rest of the Tryst to tolerate it. Anyone who killed a sorcerer now was charged with murder, anyone at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But the cooperation was threadbare and grudging. The sorcerers had expected to retain their monopoly on all forms of literacy. Wallie had bribed them with a few minor technical advances, such as soap and the basic door lock, backed up by a threat that he could and would introduce his own method of writing. So they had taught him their system, which had turned out to be syllabic, not alphabetical, but phonetic and easy to learn. He had taught others. All apprentice swordsmen now had to pass a literacy test for promotion to Third, although most of the seniors still scorned such namby-pamby affectations. Priests, healers, and traders were also taking up this arcane but useful art.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Woggan leaned back in his chair and tucked his hands farther into his sleeves. “The most likely explanation, if I may say so, Lord Shonsu, is that your Mibullim was a free sword or a guard commander who willingly swore loyalty to your tryst and was therefore accepted by Lord Nnanji as a helper. Your practice is to send high-rank recruits back here to Casr for indoctrination, is it not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I wouldn’t use that word, but yes, you are right.” Wallie rose. “And Mibullim either changed his mind on the way here or met with ill fortune. I should have thought of that eventually, I suppose.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("This pretense of stupidity made Woggan’s eyebrows shoot up like white flags. He didn’t underestimate Lord Shonsu any more than Lord Shonsu underestimated him. He might or might not know what had happened to the missing Mibullim; either way he was not about to tell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2baf3c6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section9.vue
// module id = 90
// module chunks = 0